// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1iIz9","tab":"Tabs_tab__1zni9","tabActive":"Tabs_tabActive__G3Ss_"};